import type { User } from '@/lib/pr-v2/timeline-types';
import type { OrgTeams } from '@/types/github';

export type MentionSuggestion = {
  handle: string;
  name: string;
  avatarUrl?: string;
  kind: 'user' | 'team';
};

export function getMentionSuggestions(
  users: User[],
  teams: OrgTeams | null | undefined,
  owner: string,
  searchQuery: string,
): MentionSuggestion[] {
  const userSuggestions: MentionSuggestion[] = users.map((user) => ({
    handle: user.login,
    name: user.login,
    avatarUrl: user.avatar_url,
    kind: 'user',
  }));
  const teamSuggestions: MentionSuggestion[] = (teams ?? []).map((team) => ({
    handle: `${owner}/${team.slug}`,
    name: team.name,
    kind: 'team',
  }));
  const searchTerm = searchQuery.slice(1).toLowerCase();

  // Only filter if we have a search term
  if (!searchTerm) {
    return [...userSuggestions.slice(0, 5), ...teamSuggestions.slice(0, 5)]; // Show first 5 users and teams initially
  }

  return [...userSuggestions, ...teamSuggestions].filter(
    (suggestion) =>
      suggestion.handle.toLowerCase().includes(searchTerm) ||
      suggestion.name.toLowerCase().includes(searchTerm),
  );
}
